import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import axios from 'axios';
import LeftSidebar from './LeftSidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { Link, useNavigate } from "react-router-dom";
import { MDBDataTable } from 'mdbreact';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { BASE_URL } from '../Config';

const ProductQuantity = () => {
    const navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const [data, setData] = useState({ columns: [], rows: [] });
    const [loading, setLoading] = useState(true);
    const [abstractData, setAbstractData] = useState({ columns: [], rows: [] });
    const refetchProduct= () => {
        const token = localStorage.getItem('token');
        axios.get(`${BASE_URL}/api/product_list`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
                const products = response.data.product_list;
                console.log(products);
                const rows = products.map(product => ({
                    
                    'SrNo': product.id,
                    'Product Name': product.product_name,
                    'Quantity': product.quantity,
                    'Status': product.status === 0 ? 'Active' : product.status === 4 ? 'Inactive' : 'Unknown',
                    'Add Quantity': (
                        <button 
                            className="btn btn-light text-success"
                            onClick={() => handleView(product.id)}
                        >
                            <i className="fa fa-plus-square"></i>
                        </button>
                    )
                }));

                const columns = [
                    { label: 'SrNo', field: 'SrNo', sort: 'asc', width: 150 },
                    { label: 'Product Name', field: 'Product Name', sort: 'asc', width: 270 },
                    { label: 'Quantity', field: 'Quantity', sort: 'asc', width: 270 },
                    { label: 'Status', field: 'Status', sort: 'asc', width: 270 },
                    { label: 'Add Quantity', field: 'Add Quantity', sort: 'asc', width: 100 }
                ];

                setAbstractData({ columns, rows });
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
                setLoading(false);
            });
    }
    useEffect(() => {
        refetchProduct();
    }, []);
    const [formData, setFormData] = useState({
        status: '',
        id: ''
      });
    const token = localStorage.getItem('token');
    const [showModal, setShowModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderLoading, setOrderLoading] = useState(false);
    const handleChange =(event)=>{
        const { name, value } = event.target;
        setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        }));

    }
    const handleView = (orderId) => {
        //alert(orderId);
        setOrderLoading(true);
        setShowModal(true);

        
        axios.get(`${BASE_URL}/api/product_quantity/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                setSelectedOrder(response.data.order);
                //console.log(response.data.order);
                setOrderLoading(false);
            })
            .catch(error => {
                console.error('Error fetching order details:', error);
                setOrderLoading(false);
            });
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedOrder(null);
    };
    useEffect(() => {
        if (selectedOrder) {
            setFormData({
                id: selectedOrder.id,
                status: selectedOrder.status,
            });
        }
    }, [selectedOrder]);
    const handleSubmit= async (event)=>{
        console.log("Token being sent:", token);
        event.preventDefault();
        try {
            const response = await axios.post(`${BASE_URL}/api/product_quantity_add`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            Swal.fire({
                icon: "success",
                title: "Status Update",
                text: "Order status updated successfully",
            });
            
          } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Not Updated",
            });
          } 

          setShowModal(false); 
          refetchProduct();
    }
  return (
    <div>
    <div id="page-top">
        <div id="wrapper">
            <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                    <div className="container-fluid">
                        <div className="col-md-10">
                            {successMessage && (
                                <div className="alert alert-success mt-3" role="alert">
                                    {successMessage}
                                    <button type="button" className="close" onClick={() => setSuccessMessage('')} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            )}
                            {errorMessage && (
                                <div className="alert alert-danger mt-3" role="alert">
                                    {errorMessage}
                                    <button type="button" className="close" onClick={() => setErrorMessage('')} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-header py-3' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                    <div className='row'>
                                        <div className='col-md-6 d-flex left-content-end'>
                                            <h6 className="font-weight-bold text-primary left">Products List</h6>
                                        </div>
                                        <div className='col-md-6 d-flex justify-content-end'>
                                            <Link className='btn btn-primary' to="/product"><i className="fa fa-plus mr-2"></i>Add</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body' style={{ overflowY: 'auto' }}>
                                    {loading ? (
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Spinner animation="grow" size="sm" variant="primary" />
                                            <Spinner animation="grow" size="sm" variant="primary" />
                                            <Spinner animation="grow" size="sm" variant="primary" />
                                        </div>
                                    ) : (
                                        abstractData.rows.length > 0 ? (
                                            <MDBDataTable
                                                striped
                                                bordered
                                                hover
                                                noBottomColumns={true}
                                                data={abstractData}
                                            />
                                        ) : (
                                            <p>No data available</p>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    </div>
    <Modal show={showModal} onHide={handleCloseModal}>
            <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Status Update</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {orderLoading ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner animation="grow" size="sm" variant="primary" />
                            <Spinner animation="grow" size="sm" variant="primary" />
                            <Spinner animation="grow" size="sm" variant="primary" />
                        </div>
                    ) : selectedOrder ? (
                        
                        <div>
                            <p className='text-black'><strong>Order Id: {selectedOrder.id} </strong></p>
                            <label>
                                Status
                            </label>
                            <input
                                type="hidden"
                                name="id"
                                value={selectedOrder.id}
                                required
                            />
                            
                            <input
                                type="text"
                                name="status"
                                value={selectedOrder.id}
                                required
                            />
                            
                        </div>
                    ) : (
                        <p>No order details available</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                    <Button type="submit" variant="primary" >Update</Button>
                </Modal.Footer>
                </form>
            </Modal>
    <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
    </a>
</div>
  )
}

export default ProductQuantity